import { render, staticRenderFns } from "./ConfirmDeleteSuggestedAccommodation.vue?vue&type=template&id=72f8cabb&scoped=true"
import script from "./ConfirmDeleteSuggestedAccommodation.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteSuggestedAccommodation.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteSuggestedAccommodation.vue?vue&type=style&index=0&id=72f8cabb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8cabb",
  null
  
)

export default component.exports